import { render, staticRenderFns } from "./CustomizationPage.vue?vue&type=template&id=27f948da&scoped=true&"
import script from "./CustomizationPage.vue?vue&type=script&lang=js&"
export * from "./CustomizationPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationPage.vue?vue&type=style&index=0&id=27f948da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f948da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VColorPicker,VContainer,VImg,VRow})
